import React, { useState, useEffect } from "react";
import "../styles/ChatHeader.css";
import iconImage from "../assets/mainicon.png";
import { auth } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";

const ChatHeader = ({ onButtonClick }) => {
  const [user, setUser] = useState(null);
  const [points, setPoints] = useState(localStorage.getItem("points") || 0);

  const navigate = useNavigate();

  useEffect(() => {
    // Listen for custom event
    const handlePointsUpdate = (event) => {
      const updatedPoints = event.detail.points;
      setPoints(updatedPoints);
      console.log("Points updated via custom event:", updatedPoints);
    };

    window.addEventListener("pointsUpdated", handlePointsUpdate);

    return () => {
      window.removeEventListener("pointsUpdated", handlePointsUpdate);
    };
  }, []);

  const handleLogoutClick = () => {
    auth
      .signOut()
      .then(() => {
        setUser(null);
        navigate("/signin");
      })
      .catch((error) => {
        console.error("Error signing out: ", error);
      });
  };

  const handleLoginClick = () => {
    navigate("/signin");
  };

  const handleSignUpClick = () => {
    navigate("/signup");
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser({
          displayName: user.displayName,
          email: user.email,
          photoURL: user.photoURL,
        });

        console.log(user);
      } else {
        console.log("No user logged in");
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="chatheader sticky">
      <div className="chatheader-left">
        <img src={iconImage} alt="Icon" className="header-icon" />
        <h1 className="header-title">Art Generator</h1>
      </div>
      {!user && (
        <div className="buttons d-flex">
          <button className="login-button" onClick={handleLoginClick}>
            Login
          </button>
          <button className="signup-button" onClick={handleSignUpClick}>
            Sign Up
          </button>
        </div>
      )}

      {user && (
        <div className="buttons d-flex">
          <span className="signup-button">{points} Points</span>
          <button className="signup-button" onClick={handleLogoutClick}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatHeader;
